<template>
    <nav ref="nav">
        <ul :class="{fixed}" :style="{top}">
            <li
            class="global_pointer"
                v-for="item in list"
                :key="item.id"
                :class="{current: currentId === item.id}"
                @click="handleClick(item.id);"
            >{{item.name}}</li>
        </ul>
    </nav>
</template>
<script>
import { merchants } from '@/constant/storeData'
export default {
    props: {
        top: String,
        fixed: Boolean,
        certification: Number
    },
    data() {
        return {
            list: [],
            currentId: 1
        };
    },
    watch: {
        certification: {
            handler: function (val) {
                merchants.forEach(item => {
                    if (item.storeId === this.$route.query.storeId && val === 4) {
                        this.list.push({
                            id: 5,
                            name: this.$t("message.store.certification")
                        })
                    }
                })
            },
            immediate: true
        }
    },
    created () {
        // if (lanEnv()) {
            this.list = [
                {id: 1, name: this.$t("message.store.hotSell")},
                {id: 2, name: this.$t("message.store.storeVideo")},
                // {id: 3, name: this.$t("message.store.storeInfo")},
                // {id: 4, name: this.$t("message.store.storePic")}
            ]
        // } else {
        //     this.list = [
        //             {id: 1, name: storeShop.hotSell},
        //             {id: 3, name: storeShop.storeInfo}
        //         ]
        // }
    },
    methods: {
        handleClick(id) {
            this.currentId = id;
            this.$emit('handle-click', id);
        }
    }
};
</script>
<style lang="less" scoped>
    nav {
        position: relative;
        height: 49px;
        padding-top: 5px;
        background-color: #1d1d1d;
        ul {
            display: flex;
            width: 100%;
            height: 44px;
            padding: 0 12px;
            font-size: 14px;
            color: #999999;
            &.fixed {
                position: fixed;
                left: 0;
                z-index: 99;
                background-color: #000000;
            }
            li {
                flex:1;
                line-height: 44px;
                text-align: center;
                transition: all .3s ease;
                font-family: "TradeGothicLT-Bold";
                &.current {
                    position: relative;
                    font-family: "TradeGothicLT-Bold";
                    font-size: 16px;
                    color: #39D2D6;
                    &:after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        display: block;
                        width: 15px;
                        height: 3px;
                        background-color: #39D2D6;
                        transform: translate(-50%, 0);
                    }
                }
            }
        }
    }
</style>
